import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const CounterpartyBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { close } = useCommands();
    const {
        selectedCounterpartyCount = 0,
        onCounterpartyBulkMark1099,
        onCounterpartyBulkUnmark1099,
        onCounterpartyBulkDelete,
        onCounterpartyBulkCreateTask,
    } = options;

    const heading = `${pluralizeWithCount("counterparty", selectedCounterpartyCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onCounterpartyBulkMark1099 && (
                <CommandItem
                    keywords={["1099", "eligible", "mark", "tax"]}
                    onSelect={() => {
                        close();
                        void onCounterpartyBulkMark1099();
                    }}
                    shortcut="m"
                >
                    Mark 1099 eligible
                </CommandItem>
            )}
            {onCounterpartyBulkUnmark1099 && (
                <CommandItem
                    keywords={["1099", "eligible", "unmark", "remove", "tax"]}
                    onSelect={() => {
                        close();
                        void onCounterpartyBulkUnmark1099();
                    }}
                    shortcut="u"
                >
                    Unmark 1099 eligible
                </CommandItem>
            )}
            {onCounterpartyBulkCreateTask && (
                <CommandItem
                    keywords={["task", "create"]}
                    onSelect={() => {
                        close();
                        onCounterpartyBulkCreateTask();
                    }}
                    shortcut="t"
                >
                    Create task
                </CommandItem>
            )}
            {onCounterpartyBulkDelete && (
                <CommandItem
                    keywords={["delete", "remove"]}
                    onSelect={() => {
                        close();
                        void onCounterpartyBulkDelete();
                    }}
                    shortcut="d"
                >
                    Delete
                </CommandItem>
            )}
        </Command.Group>
    );
};
